import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { showResult } from 'utils';
import forms from 'constants/forms';
import CovidIcon from '../icons/covidIcon';
import ControlPanelButton from '../controlPanelButton';
import UpdatePatientCovidStatusModal from './updatePatientCovidStatusModal';

const PatientStatusAndCovidStatus = ({ profile, patientDetailsLoading }) => {
  const { guid, covidStatus } = profile;
  const {
    adminPanelPatients: { setCovidStatus },
    covid: { submit: submitCovidStatus },
  } = useDispatch();

  const covidStatusSubmitLoading = useSelector(
    (state) => state.loading.effects.covid.submit,
  );

  const [covidPopupOpen, setCovidStatusPopupOpen] = useState(false);

  const sendCovidStatusUpdateRequest = async (postData) => {
    const { error, data } = await submitCovidStatus(postData);
    if (!error && data) {
      setCovidStatus(data.covidStatus);
    }
    showResult(error, null, setCovidStatusPopupOpen);
  };

  return (
    <>
      <div className="admin-patient-header-actions-call">
        <ControlPanelButton
          label="Update Covid Status"
          icon={CovidIcon}
          handleClick={() => setCovidStatusPopupOpen(true)}
          disabled={patientDetailsLoading || covidStatusSubmitLoading}
        />
      </div>
      {!patientDetailsLoading && (
        <UpdatePatientCovidStatusModal
          isOpen={covidPopupOpen}
          toggle={setCovidStatusPopupOpen}
          patientGuid={guid}
          patientCovidStatus={covidStatus}
          options={forms.patientCovidStatuses}
          loading={covidStatusSubmitLoading}
          submit={sendCovidStatusUpdateRequest}
        />
      )}
    </>
  );
};

PatientStatusAndCovidStatus.defaultProps = {
  patientDetailsLoading: false,
};

PatientStatusAndCovidStatus.propTypes = {
  profile: PropTypes.shape().isRequired,
  patientDetailsLoading: PropTypes.bool,
};

export default PatientStatusAndCovidStatus;
